export const ROUTES = {
  Home: "/",
  Jets: "/jets",
  Experience: "/experience",
  Story: "/our-story",
  Sponsoring: "/sponsoring",
  Imprint: "/imprint",
  PrivacyPolicy: "/privacy-policy",
  Career: "/career"
}